<template>
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
  >
    <path d="M4.00002 1.5H5V7.73821C5 8.11316 4.9063 8.48216 4.72742 8.81168L1.14271 15.415C0.509702 16.5811 1.3539 17.9999 2.68071 17.9999H13.3193C14.6461 17.9999 15.4903 16.5811 14.8573 15.415L11.2726 8.81168C11.0937 8.48216 11 8.11316 11 7.73821V1.5H12C12.4142 1.5 12.75 1.16421 12.75 0.75C12.75 0.335786 12.4142 0 12 0H4.00002C3.58581 0 3.25002 0.335786 3.25002 0.75C3.25002 1.16421 3.58581 1.5 4.00002 1.5ZM6.5 7.73821V1.5H9.5V7.73821C9.5 8.36312 9.65616 8.97812 9.9543 9.52732L10.7538 11H5.24623L6.04569 9.52732C6.34383 8.97812 6.5 8.36312 6.5 7.73821ZM4.43194 12.5H11.5681L13.539 16.1307C13.6294 16.2973 13.5088 16.4999 13.3193 16.4999H2.68071C2.49116 16.4999 2.37056 16.2973 2.46099 16.1307L4.43194 12.5Z" />
  </svg>
</template>
